import gql from "graphql-tag";

export const MODERATE_OPTIONS_MUTATION = gql`
  mutation ModerateOptions($input: ModerateOptionsInput!) {
    success: moderateOptions(input: $input)
  }
`;

export {
  ModerateOptions,
  ModerateOptionsVariables,
  ModerationOptionInput as IModerationOptionInput,
  ModerateOptionsInput as IModerateOptionsInput
} from "~/graphql/types";



// WEBPACK FOOTER //
// ./src/graphql/mutations/optionModeration/moderateOptions.ts